{
  "id": "empty",
  "displayName": "Empty",
  "solid": false,
  "destructible": false,
  "displayColor": "#000000"
}
